import { render, staticRenderFns } from "./xrld.vue?vue&type=template&id=65afd594&scoped=true"
import script from "./xrld.vue?vue&type=script&lang=js"
export * from "./xrld.vue?vue&type=script&lang=js"
import style0 from "./xrld.vue?vue&type=style&index=0&id=65afd594&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65afd594",
  null
  
)

export default component.exports